import { render, staticRenderFns } from "./SupportBottomMenu.vue?vue&type=template&id=64c11d2f&scoped=true&"
import script from "./SupportBottomMenu.vue?vue&type=script&lang=js&"
export * from "./SupportBottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./SupportBottomMenu.vue?vue&type=style&index=0&id=64c11d2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c11d2f",
  null
  
)

export default component.exports